import { InMemoryCache } from '@apollo/client';

import { fragmentRegistry } from './fragments/fragmentRegistry';
import { possibleTypes } from './possibleTypes';
import { typePolicies } from './typePolicies';

// eslint-disable-next-line @trello/no-module-logic
export const cache = new InMemoryCache({
  possibleTypes,
  typePolicies,
  fragments: fragmentRegistry,
  resultCacheMaxSize: 200000,
});
